import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M16,20H8c-.553,0-1-.448-1-1s.447-1,1-1h8c.553,0,1,.448,1,1s-.447,1-1,1Zm6-1V5c0-2.757-2.243-5-5-5H7C4.243,0,2,2.243,2,5v14c0,2.757,2.243,5,5,5h10c2.757,0,5-2.243,5-5ZM17,2c1.654,0,3,1.346,3,3v14c0,1.654-1.346,3-3,3H7c-1.654,0-3-1.346-3-3V5c0-1.654,1.346-3,3-3h10Zm-5.954,9c.107,2.564,.435,4.829,.977,4.829s.87-2.265,.977-4.829h-1.954Zm3.562-5.334c-.102-.493,.466-.839,.877-.548,1.271,.902,2.178,2.282,2.448,3.882h-2.935c-.039-.861-.14-2.119-.39-3.334Zm-2.585-1.495c.561,0,.87,2.265,.977,4.829h-1.954c.107-2.564,.416-4.829,.977-4.829Zm-2.585,1.495c-.251,1.215-.351,2.473-.39,3.334h-2.935c.27-1.6,1.177-2.98,2.448-3.882,.41-.291,.978,.055,.877,.548Zm5.169,8.668c.251-1.215,.351-2.473,.39-3.334h2.935c-.27,1.6-1.177,2.98-2.448,3.882-.41,.291-.978-.055-.877-.548Zm-5.169,0c.102,.493-.466,.839-.877,.548-1.271-.902-2.178-2.282-2.448-3.882h2.935c.039,.861,.14,2.119,.39,3.334Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/passport-icon.jsx